// extracted by mini-css-extract-plugin
export default {"wrapper":"text-area-module--wrapper---p7Na"};